import React from 'react';
import { Clock, MessageCircle, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getDigitalInviteOrderWhatsappUrl } from '@/lib/digitalInvitesWhatsapp';

const stepIcons = [Sparkles, MessageCircle, Clock];

export function DigitalInvitesHowToOrderSection({ copy }) {
  const openWhatsapp = () => {
    window.open(getDigitalInviteOrderWhatsappUrl(copy.orderWhatsappModelGeneric), '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="digital-invites-how-to-order" className="max-w-6xl mx-auto mb-20 sm:mb-28 scroll-mt-28 min-w-0">
      <div className="rounded-[2rem] border border-white/[0.1] bg-slate-950/50 backdrop-blur-xl overflow-hidden relative shadow-[0_32px_100px_-48px_rgba(245,158,11,0.15)]">
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-br from-amber-500/[0.06] via-transparent to-violet-500/[0.04]" aria-hidden />
        <div className="relative px-6 sm:px-10 py-10 sm:py-12">
          <h2 className="text-center text-xl sm:text-3xl font-black text-white tracking-tight uppercase break-words mb-10 sm:mb-12">
            {copy.sectionHowToOrderTitle}
          </h2>

          <div className="grid gap-6 md:grid-cols-3 mb-8 sm:mb-10">
            {copy.howToOrderSteps.map((step, i) => {
              const Icon = stepIcons[i] || Sparkles;
              return (
                <article
                  key={step.title}
                  className="relative rounded-2xl border border-white/[0.08] bg-slate-950/60 backdrop-blur-md p-6 pt-10 text-center hover:border-amber-500/25 transition-colors duration-300"
                >
                  <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 border border-amber-400/40 flex items-center justify-center shadow-lg shadow-amber-900/30">
                    <Icon className="w-5 h-5 text-slate-950" aria-hidden />
                  </div>
                  <h3 className="text-base font-bold text-white mb-2 break-words">{step.title}</h3>
                  <p className="text-sm text-white/50 font-light leading-relaxed break-words">{step.desc}</p>
                </article>
              );
            })}
          </div>

          <p className="text-center text-sm sm:text-base text-white/45 font-light leading-relaxed max-w-3xl mx-auto mb-8 break-words">
            {copy.howToOrderNote}
          </p>

          <div className="flex justify-center">
            <Button
              type="button"
              onClick={openWhatsapp}
              className="rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 text-slate-950 font-bold px-8 h-12 shadow-lg shadow-amber-900/25 hover:from-amber-400 hover:to-amber-500"
            >
              {copy.btnOrderNow}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
